import React, {
    useEffect,
    useState
} from "react";

import styled
    from "styled-components";
import TextField
    from "@components/forms/fields/TextField";

const OtherContainer = styled.div`
  margin-top: 0.5rem;
`

export default function useFormMultipleField({
                                                 template = {},
                                                 values = {},
                                                 defaultAnswer = {},
                                                 onChange,
                                                 disabled = false,
                                                 hiddenLabel = false,
                                             }) {
    const [otherFieldValue, setOtherFieldValue] = useState("");
    const [otherFieldCount, setOtherFieldCount] = useState(0);

    const {
        content,
        name,
    } = template;

    const {
        choiceType,
        ignoreIfHidden,
        value: possibleValues,
    } = content;

    const allowOther = content.allowOther === 1;

    const {value: submissionValue} = values;

    let answerObject = {};
    if (submissionValue && Object.keys(submissionValue).length > 0) {
        answerObject = submissionValue;
    } else if (Object.keys(defaultAnswer).length > 0) {
        answerObject = defaultAnswer;
    }

    // Build an array of options
    const initialOptions = [];

    Object.keys(possibleValues).map((key) => {
        initialOptions.push({
            id: key,
            ...possibleValues[key]
        });
    });

    const valueBasedOptions = [];
    const valueBasedOptionIndexes = Object.keys(answerObject).filter(key => initialOptions.findIndex(option => option.item == answerObject[key]) == -1);

    for (const valueBasedOptionIndex of valueBasedOptionIndexes) {
        if (valueBasedOptionIndex && answerObject[valueBasedOptionIndex] && answerObject[valueBasedOptionIndex].length > 0) {
            valueBasedOptions.push({
                id: valueBasedOptionIndex,
                item: answerObject[valueBasedOptionIndex]
            });
        }
    }

    const [options, setOptions] = useState([
        ...initialOptions,
        ...valueBasedOptions
    ]);
    const className = `fz-form-field-multiple fz-form-field-${choiceType}`;

    // Strip out 'other'
    const {
        other,
        ...answers
    } = answerObject;

    const otherInputProps = {};

    if (hiddenLabel) {
        otherInputProps.label = 'Other';
    }

    const handleAddOtherField = () => {
        const otherFieldKey = `_${otherFieldCount + 1}`;

        const newOption = {
            [otherFieldKey]: otherFieldValue
        };

        onChange(newOption, choiceType === 'checkbox' ? 'APPEND_ANSWER' : 'UPDATE_ANSWER');

        // setOptions([
        //     ...options,
        //     {
        //         id: otherFieldKey,
        //         item: otherFieldValue
        //     }
        // ]);

        setOtherFieldValue("");
        setOtherFieldCount(otherFieldCount + 1);
    }

    useEffect(() => {
        const newOptions = [];

        for (const key in values.value) {
            if (key !== 'other' && options.find(option => option.item === values.value[key]) === undefined) {
                newOptions.push({
                    id: key,
                    item: values.value[key]
                });
            }
        }

        if (newOptions.length > 0) {
            setOptions([
                ...options,
                ...newOptions
            ])
        }
    }, [values.value, options])

    const otherElement = (disabled = false) => {
        return allowOther && (
            <OtherContainer className='fz-form-element-multiple-other'>
                {!hiddenLabel &&
                <label className='fz-form-field-label' htmlFor={`${template.id}-other`}>Other</label>}
                <TextField id={`${template.id}-other`}
                           fullWidth
                           disabled={disabled}
                           value={otherFieldValue}
                           onChange={event => setOtherFieldValue(event.target.value)}
                           onBlur={() => {
                               if (otherFieldValue.length > 0) {
                                   handleAddOtherField();
                               }
                           }}
                           onKeyDown={(event) => {
                               if (event.keyCode === 13) {
                                   event.preventDefault();

                                   if (otherFieldValue.length > 0) {
                                       handleAddOtherField();
                                   }
                               }
                           }}
                           name={`${name}-other`}
                           {...otherInputProps}
                />
            </OtherContainer>
        );
    }

    const otherProps = {
        className,
        required: values.required
    }

    if (disabled === true) {
        otherProps.disabled = true;
    }

    return {
        otherFieldValue,
        setOtherFieldValue,
        otherFieldCount,
        setOtherFieldCount,
        options,
        setOptions,
        initialOptions,
        className,
        submissionValue,
        answerObject,
        answers,
        otherProps,
        otherElement,
        choiceType
    }
}